import { BUILD_TIER, TIER, TIER_LABEL } from '../platform/access/tier'
import './tierBadge.css'

/**
 * The entitlement tier this page load grants — #477. Every build except
 * production, the same as `BackendBadge`.
 *
 * Reads `TIER`, the value `main.tsx` built `BillingProvider`'s `baseline` from,
 * rather than re-resolving the override, so the badge and the baseline cannot
 * disagree. It names the BUILD's grant, not the user's entitlements: on staging
 * (tier Free) a real subscriber's RevenueCat entitlements are added on top, so
 * the badge can read Free while their gates are open. It says "override" only when that differs from `BUILD_TIER`, the
 * build's own tier before any developer choice.
 *
 * Rendered by `TopBar` behind `import.meta.env.MODE !== 'production'`,
 * alongside `BackendBadge`, so a production build drops this module too.
 */
export function TierBadge() {
  const overridden = TIER !== BUILD_TIER
  return (
    <p className="chrome-badge tier-badge" data-testid="tier-badge">
      <span className="tier-badge__label">Tier</span>{' '}
      <span className="tier-badge__value">{TIER_LABEL[TIER]}</span>
      {overridden && (
        <>
          {' '}
          <span className="tier-badge__override">override</span>
        </>
      )}
    </p>
  )
}
